<template>
	<div
		class="g-block-body-solid g-block-body-padding"
		:class="{
			'g-block-body-solid--edit': editable,
			'is-active': editable && active,
			'g-block-body-solid--h5': h5,
			'g-block-body-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div
			class="g-block-body-solid__panel"
			:style="{ background: themeColor }"
		>
			<RichTextEditable
				v-if="editable"
				class="g-block-body-solid__text"
				:model-value="data.content"
				placeholder="请输入正文"
				@update:model-value="onContentUpdate"
				@focus="onWrapClick"
			/>
			<div
				v-else
				class="g-block-body-solid__text"
				v-html="data.content || ''"
			></div>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { getTitleThemeColor } from '../../../templates.js';
	import { bodyMixin } from '../shared/bodyMixin.js';

	export default {
		name: 'GBlockBodySolid',
		components: { RichTextEditable },
		mixins: [bodyMixin],
		computed: {
			themeColor() {
				return getTitleThemeColor(this.data);
			},
		},
	};
</script>

<style scoped lang="less">
	@import '../shared/bodyEditShell.less';

	.g-block-body-solid {
		.body-block-edit-shell();
	}

	.g-block-body-solid__panel {
		border-radius: 6px;
		padding: 14px;
		box-sizing: border-box;
	}

	.g-block-body-solid__text {
		.body-text-base();
		color: #fff;

		:deep(.g-rich-text-editable__content) {
			color: #fff;
		}
	}

	.g-block-body-solid--h5 {
		.g-block-body-solid__panel {
			border-radius: 0.12rem;
			padding: 0.28rem;
		}
		.body-text-base--h5(~'.g-block-body-solid__text');
	}
</style>
